const FAST_COMPLETE_NOTIFICATION_TAG = 'fast-complete'

/**
 * Returns whether the Notification API is available and permitted.
 *
 * @returns True when a notification can be shown.
 */
export function canShowNotification() {
   return 'Notification' in window && Notification.permission === 'granted'
}

/**
 * Shows the "fast complete" notification, via the service worker when one is
 * registered so it also works while the page is in the background.
 *
 * @param intendedDurationLabel - The formatted intended fast duration.
 */
export async function showFastCompleteNotification(intendedDurationLabel: string) {
   const title = 'Fast Complete'
   const options = {
      body: `You've completed ${intendedDurationLabel} of fasting.`,
      tag: FAST_COMPLETE_NOTIFICATION_TAG,
      renotify: false,
      data: { completedAt: Date.now() },
   }
   const registration =
      typeof navigator.serviceWorker?.getRegistration === 'function' ?
         await navigator.serviceWorker.getRegistration()
      :  undefined
   if (registration && typeof registration.showNotification === 'function') {
      await registration.showNotification(title, options)
   } else {
      new Notification(title, options)
   }
}
